import { Ranking } from '../components/home/ranking';
import { useLeaderboardGlobal } from '../query';
import styles from './board.module.css';

export const Board = () => {
  const {
    isError,
    isLoading,
    data: users,
  } = useLeaderboardGlobal();

  if (isLoading || isError) return null;

  return (
    <ol className={ styles.board }>
      { users.map((user, idx) => (
        <Ranking
          as="li"
          key={ idx }
          user={ user }
          idx={ idx }
        />
      )) }
    </ol>
  );
};